import React, { useState } from 'react'
import './Form.css'
import { useSignUp } from '../hooks/useSignUp'

const Signup = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [type, setType] = useState('password')
    const { signup, isLoading, error } = useSignUp()

    const handleSubmit = async(e) => {
        e.preventDefault()
        console.log({name, email, password});

        await signup(name, email, password)
    }

    const changeType = (e) => {
        e.preventDefault()
        if(type === 'password') setType('text')
        else setType('password')
    }

    // useEffect(() => {
    //     setName('')
    //     setEmail('')
    //     setPassword('')
    // },[])

  return (
   <form className='form'>
    <h3>Sign Up</h3>
    <label>Name : </label>
    <input 
        type="text" 
        placeholder='Enter your name'    
        onChange={(e) => setName(e.target.value)}
        value={name}
        />
    <label>Email : </label>
    <input 
        type="email" 
        placeholder='Enter your email'    
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        />
    <div className="password">
        <label>Password : </label>
        <input 
            type={type} 
            placeholder='Enter your password'    
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            />
        <button onClick={changeType} className='eyeIcon'>&#128065;</button>
    </div>
    <button disabled={isLoading} onClick={handleSubmit}>Sign Up</button>
    {error && <p className='error'>{error}</p> }
   </form>
  )
}

export default Signup